import { z } from 'zod';
import { get } from './client';
import {
  AttributionSummarySchema, DatesResponseSchema, FundDescriptorSchema,
  SqlInspectorSchema,
  StrategiesResponseSchema, PositionsResponseSchema, WinnersResponseSchema,
  DrilldownResponseSchema, ExposureResponseSchema, TreasuryResponseSchema,
  CommoditiesResponseSchema,
} from './schemas';

const FundsListSchema = z.array(FundDescriptorSchema);

export const attributionApi = {
  funds: () => get('/funds', FundsListSchema),

  dates: (fund: string) =>
    get('/dates', DatesResponseSchema, { params: { fund } }),

  summary: (fund: string, date: string) =>
    get('/attribution/summary', AttributionSummarySchema, { params: { fund, date } }),

  strategies: (fund: string, date: string) =>
    get('/attribution/strategies', StrategiesResponseSchema, { params: { fund, date } }),

  positions: (fund: string, date: string, filter: string = 'core') =>
    get('/attribution/positions', PositionsResponseSchema, { params: { fund, date, filter } }),

  winners: (fund: string, date: string, period: string) =>
    get('/attribution/winners', WinnersResponseSchema, { params: { fund, date, period } }),

  drilldown: (fund: string, date: string, search: string = '') =>
    get('/attribution/strategy-drilldown', DrilldownResponseSchema, {
      params: { fund, date, search },
    }),

  exposure: (fund: string, date: string) =>
    get('/attribution/exposure', ExposureResponseSchema, { params: { fund, date } }),

  treasury: (fund: string, date: string) =>
    get('/attribution/treasury', TreasuryResponseSchema, { params: { fund, date } }),

  commodities: (fund: string, date: string) =>
    get('/attribution/commodities', CommoditiesResponseSchema, { params: { fund, date } }),

  sqlInspector: (key: string, fund?: string, date?: string) =>
    get(`/sql/attribution/${key}`, SqlInspectorSchema, { params: { fund, date } }),
};
